import React from 'react';
import BaseIcon from './BaseIcon.js';

const IconStatus = function ({ size }) {
  return (
    <BaseIcon viewBox="0 0 256 256" size={size}>
      <rect fill="none" height="256" width="256">
      </rect>
      <path d="M245.7,85.7l-40,40a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L220.7,88H176a40,40,0,0,0-40,40,56,56,0,0,1-56,56h-.9a36,36,0,1,1,0-16H80a40,40,0,0,0,40-40,56,56,0,0,1,56-56h44.7L194.3,45.7a8.1,8.1,0,0,1,11.4-11.4l40,40A8.1,8.1,0,0,1,245.7,85.7Z">
      </path>
    </BaseIcon>
  );
}

export default IconStatus;
